// src/features/audit-monitor/components/AuditOrdersList/AuditOrdersList.js
import React from 'react';
import { func } from 'prop-types';
import { get, map } from 'lodash';
import { Divider } from 'antd';
import { FlexContainer, Loading, Accordion, Row, Text, If, NotFound } from '../../../../components/common';
import { isPluralFix } from '../../../../utils/misc';
import { LoadingComponent } from '../shared/LoadingComponent';
import AuditSingleOrderCard from './AuditSingleOrderCard';
import AuditGroupOrdersCard from './AuditGroupOrdersCard';
import { BLUE } from '../../../../utils/colors';

const styleCard = {
    backgroundColor: 'white',
    border: '1px solid #e8e8e8',
    borderRadius: 8,
    boxShadow: '0px 4px 12px 0px #00000014',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: 13,
    alignItems: 'center'
}

const AuditOrderCardList = ({ onOrderClick, groupedData, hasData, loading, error }) => {
    if (error) {
        console.error('Error loading audit data:', error);
    }

    const renderItem = (item, index) => {
        const itemType = get(item, 'type');

        if (itemType === 'bipicking-group') {
            return (
                <AuditGroupOrdersCard
                    style={styleCard}
                    key={index}
                    group={item}
                    onOrderClick={onOrderClick}
                />
            );
        }

        const bipicking = get(item, 'assignInfo.bipicking', false);
        const partnerId = bipicking 
            ? get(item, 'assignInfo.ordersBipicking', []).find(id => id !== get(item, 'id'))
            : null;

        return (
            <AuditSingleOrderCard
                data={item}
                onOrderClick={onOrderClick}
                style={styleCard}
                key={index}
                bipickingInfo={bipicking && partnerId ? {
                    isBipicking: true,
                    iconName: 'bipicking-a',
                    iconColor: BLUE,
                    partnerId,
                    showRelatedLabel: true
                } : null}
            />
        );
    };

    const getVisibleItemsCount = (items) => {
        let count = 0;
        items.forEach(item => {
            const itemType = get(item, 'type');
            if (itemType === 'bipicking-group') {
                count += 2;
            } else if (itemType !== 'individual-bipicking') {
                count += 1;
            }
        });
        return count;
    };

    // Grid style optimizado para bipicking
    const gridStyle = {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
        gap: 10,
        padding: 20,
        boxSizing: 'border-box'
    };

    return (
        <Loading loading={loading}>
            <If
                condition={!hasData}
                then={
                    <FlexContainer justify='center' style={{ minHeight: 'calc(90vh - 55px)' }}>
                        <NotFound firstTextLine='No se encontraron pedidos por auditar' />
                    </FlexContainer>
                }
                else={
                    <FlexContainer direction='column' style={{ padding: '0px 23px' }}>
                        {map(groupedData, (items, label) => (
                            <Accordion
                                key={label}
                                title={
                                    <Row align='center'>
                                        <Text text={label} strong size={14} />
                                        <Divider type='vertical' />
                                        <Text 
                                            text={`${getVisibleItemsCount(items)} ${isPluralFix(getVisibleItemsCount(items), 'pedidos')} por auditar`} 
                                            size={12} 
                                            color='#848484' 
                                        />
                                    </Row>
                                }
                                background='#f4f4f4;'
                                closedBackground='white'
                                style={{ 
                                    boxShadow: '0px 4px 12px 0px #00000014', 
                                    margin: '15px 0px', 
                                    borderRadius: 8 
                                }}
                                defaultOpened
                            >
                                <If
                                    condition={loading}
                                    then={<LoadingComponent />}
                                    else={<div style={gridStyle}>
                                        {items.map(renderItem)}
                                    </div>}
                                />
                            </Accordion>
                        ))}
                    </FlexContainer>
                }
            />
        </Loading>
    );
};

AuditOrderCardList.propTypes = {
    onOrderClick: func.isRequired
};

export default AuditOrderCardList;